import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ValidateAndExtractScormPackageMutationVariables = Types.Exact<{
  key: Types.Scalars['String']['input'];
}>;


export type ValidateAndExtractScormPackageMutation = { __typename?: 'Mutation', validateAndExtractScormPackage: { __typename?: 'ValidateAndExtractScormPackageMutationResult', scormValidationError?: Types.ScormValidationErrorType | null, success: boolean, scormUpload?: { __typename?: 'SCORMUpload', id: string } | null, error?: { __typename?: 'Error', code: string, message?: string | null } | null } };

export type ConvertScormPackageMutationVariables = Types.Exact<{
  key: Types.Scalars['String']['input'];
}>;


export type ConvertScormPackageMutation = { __typename?: 'Mutation', convertSCORMPackage: { __typename?: 'SCORMPackageConversionMutationResult', success: boolean, scormUpload?: { __typename?: 'SCORMUpload', id: string, moduleVersion?: { __typename?: 'ModuleVersion', id: string, module: { __typename?: 'Module', id: number, libraryItem: { __typename?: 'LibraryItem', id: string } } } | null } | null, error?: { __typename?: 'Error', code: string } | null } };


export const ValidateAndExtractScormPackageDocument = gql`
    mutation ValidateAndExtractScormPackage($key: String!) {
  validateAndExtractScormPackage(key: $key) {
    scormUpload {
      id
    }
    scormValidationError
    success
    scormValidationError
    error {
      code
      message
    }
  }
}
    `;
export type ValidateAndExtractScormPackageMutationFn = Apollo.MutationFunction<ValidateAndExtractScormPackageMutation, ValidateAndExtractScormPackageMutationVariables>;

/**
 * __useValidateAndExtractScormPackageMutation__
 *
 * To run a mutation, you first call `useValidateAndExtractScormPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateAndExtractScormPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateAndExtractScormPackageMutation, { data, loading, error }] = useValidateAndExtractScormPackageMutation({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useValidateAndExtractScormPackageMutation(baseOptions?: Apollo.MutationHookOptions<ValidateAndExtractScormPackageMutation, ValidateAndExtractScormPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateAndExtractScormPackageMutation, ValidateAndExtractScormPackageMutationVariables>(ValidateAndExtractScormPackageDocument, options);
      }
export type ValidateAndExtractScormPackageMutationHookResult = ReturnType<typeof useValidateAndExtractScormPackageMutation>;
export type ValidateAndExtractScormPackageMutationResult = Apollo.MutationResult<ValidateAndExtractScormPackageMutation>;
export type ValidateAndExtractScormPackageMutationOptions = Apollo.BaseMutationOptions<ValidateAndExtractScormPackageMutation, ValidateAndExtractScormPackageMutationVariables>;
export const ConvertScormPackageDocument = gql`
    mutation ConvertSCORMPackage($key: String!) {
  convertSCORMPackage(key: $key) {
    scormUpload {
      id
      moduleVersion {
        id
        module {
          id
          libraryItem {
            id
          }
        }
      }
    }
    success
    error {
      code
    }
  }
}
    `;
export type ConvertScormPackageMutationFn = Apollo.MutationFunction<ConvertScormPackageMutation, ConvertScormPackageMutationVariables>;

/**
 * __useConvertScormPackageMutation__
 *
 * To run a mutation, you first call `useConvertScormPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertScormPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertScormPackageMutation, { data, loading, error }] = useConvertScormPackageMutation({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useConvertScormPackageMutation(baseOptions?: Apollo.MutationHookOptions<ConvertScormPackageMutation, ConvertScormPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConvertScormPackageMutation, ConvertScormPackageMutationVariables>(ConvertScormPackageDocument, options);
      }
export type ConvertScormPackageMutationHookResult = ReturnType<typeof useConvertScormPackageMutation>;
export type ConvertScormPackageMutationResult = Apollo.MutationResult<ConvertScormPackageMutation>;
export type ConvertScormPackageMutationOptions = Apollo.BaseMutationOptions<ConvertScormPackageMutation, ConvertScormPackageMutationVariables>;